import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import styles from './common.module.less'

const CommonError = (): JSX.Element => {
  const msg = location.search?.split('=')[1] || '出错啦！请联系开发人员'

  return <>
    <BrowserRouter>
      <div className={styles.message}>
        <h2>{decodeURI(msg)}</h2>
      </div>
    </BrowserRouter>
  </>
}
export default CommonError
